<!-- <p-toast key="tk" position="top-right"></p-toast> -->
<div class="token-login-container w-100 h-100">
    <ng-container *ngIf="!this.tokenUnlockService.tokenBlockError; else tokenBlocked">
        <div *ngIf="queryLoading" class="query-loading-container">
            <div class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
                </div>
            </div>
        </div>

        <form *ngIf="!queryLoading && !queryError" [formGroup]="loginTokenForm" (ngSubmit)="validateToken()">
            <!-- cambiar  queryerror a true para pruebas -->
            <div class="user-name-container">
                <div class="username-icon">
                    <img src="assets/images/icons/account_circle.svg">
                </div>
                <div class="user-name">{{ fullName }}</div>
            </div>
            <div class="secret-words-container">
                <span class="secret-words">{{ this.secret }}</span>
            </div>
            <div class="token-input-container">
                <div class="p-password">
                    <label for="token" class="form-label w-100">{{ 'Clave del token' | translate }}</label>
                    <p-password [inputStyleClass]="showLoginError ? 'error-class' : ''" formControlName="token"
                                class="w-100 " id="token" [feedback]="false" [toggleMask]="true"
                                [maxLength]="8"></p-password>
                    <span *ngIf="showValidateError"
                          class="tokenError">{{ "Token debe ser 6 caracteres"|translate }}</span>
                    <span *ngIf="requiereSiguiente"
                          class="tokenNext">{{ "Se requiere el token siguiente"|translate }}</span>
                </div>
                <div class="error-message-container w-100">
                    <small *ngIf="showLoginError"
                           class="p-error block">{{ 'Código de Token Inválido' | translate }}</small>
                </div>
            </div>
            <div class="btns-actions d-flex">
                <button type="submit" class="btn-primary validate-token-btn"
                        [disabled]="!loginTokenForm.valid || loading">
                    <ng-container *ngIf="!loading; else loadingtBtn">
                        {{ 'Ingresar' | translate }}
                    </ng-container>
                    <ng-template #loadingtBtn class="loading label-btn">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        {{ 'Validando'|translate }}...
                    </ng-template>
                </button>
                <button type="button" class="btn-outline-primary btn exit-token-btn ms-3 label-btn"
                        (click)="onLogOut()">
                    <span class="label-btn">  {{ 'Salir' | translate }}</span>
                </button>
            </div>
            <div class="cancel-token-action" (click)="showAuthorizationToCancelToken()" style="cursor: pointer;">
                {{ 'Cancelar Token' | translate }}
            </div>
        </form>


        <div *ngIf="!queryLoading && queryError" class="info-container">
            <div class="user-name-container">
                <div class="username-icon">
                    <img src="assets/images/icons/account_circle.svg">
                </div>
                <div class="user-name">{{ fullName }}</div>
            </div>
            <div class="secret-words-container">
                <span class="secret-words">{{ this.secret }}</span>
            </div>
            <div *ngIf="this.sitTokenValue === sitToken.BL || this.sitTokenValue === sitToken.BI">
                <div class="error-token-container">
                    <div class="message">
                        <span>{{ 'UI-INTENTOS-AGOTADOS' | translate }}</span>
                    </div>
                </div>
                <div class="container-fluid mt-3">
                    <div class="row justify-content-left gap-3">
                        <button
                                type="submit"
                                class="btn-primary btn validate-token-btn col-md-auto"
                                (click)="SendEmailToUnlockToken()"
                        >
                            <span class="label-btn" *ngIf="!loading">{{ 'Desbloquear token' | translate }}</span>
                            <div *ngIf="loading" class="loading label-btn">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                {{ "Validando"|translate }}...
                            </div>
                        </button>
                        <button type="button" class="btn-outline-primary btn exit-token-btn label-btn col-md-auto"
                                (click)="onLogOut()">
                            <span class="label-btn">  {{ 'Salir' | translate }}</span>
                        </button>

                    </div>
                </div>
            </div>


            <div *ngIf="this.sitTokenValue === sitToken.SYNC_TOKEN" class="w-100" (submit)="syncToken()">
                <div class="sync-token-container">
                    <div class="sync-token-title mt-3">
                        {{ 'syncToken.title' | translate }}
                    </div>
                    <form class="w-100" [formGroup]="syncTokenForm">
                        <label for="previousToken"
                               class="form-label w-100"> {{ 'syncToken.label1' | translate }}</label>
                        <div class="sync-token-input">
                            <p-password [inputStyleClass]="showLoginError ? 'error-class' : ''"
                                        formControlName="token1"
                                        class="w-100 test" id="previousToken" [feedback]="false" [toggleMask]="true"
                                        [maxLength]="8">

                            </p-password>
                        </div>
                        <label for="nextToken"
                               class="form-label w-100"> {{ 'syncToken.label2' | translate }}</label>
                        <div class="sync-token-input">
                            <p-password [inputStyleClass]="showLoginError ? 'error-class' : ''"
                                        formControlName="token2"
                                        class="w-100 " id="nextToken" [feedback]="false" [toggleMask]="true"
                                        [maxLength]="8">

                            </p-password>
                        </div>
                        <div class="error-message-container w-100">
                            <small *ngIf="showSyncError"
                                   class="p-error block">{{ 'syncToken.error' | translate }}</small>
                        </div>
                        <div class="sync-token-btns-container mt-5">
                            <button type="submit"
                                    class="btn-primary btn validate-token-btn col-md-auto"
                                    [disabled]="!syncTokenForm.valid || loadingSynchronizing">
                                <span *ngIf="!loadingSynchronizing">
                                    {{ "syncToken.syncButton" | translate }}
                                </span>
                                <div *ngIf="loadingSynchronizing">
                                     <span class="spinner-border spinner-border-sm"
                                           role="status" aria-hidden="true"></span>
                                    {{ 'syncToken.loading' | translate }}...
                                </div>
                            </button>
                            <button type="button"
                                    (click)="onLogOut()"
                                    class="btn-outline-primary btn exit-token-btn label-btn col-md-auto ms-3">
                                {{ 'Salir' | translate }}
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #tokenBlocked>
        <div *ngIf="this.tokenUnlockService.tokenBlockError" class="info-container">
            <lib-access-disabled></lib-access-disabled>
        </div>
    </ng-template>
</div>

<div class="change-password-modal w-100 " *ngIf="showChangePasswordModal">
    <p-dialog
            [(visible)]="showChangePasswordModal"
            [modal]="true"
            [style]="{ top: '60px'}"
            [showHeader]="false"
            position="top"
            [draggable]="false">
        <div style="width: 450px" class="p-3 pt-4">
            <a id="close-change-password-modal-icon" class="close-change-password-modal-icon"
               (click)="closeChangeModalPassword()">
                <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
            </a>
            <div class="icon text-center">
                <svg width="40" height="36" viewBox="0 0 40 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4.3125 35.75H35.6875C38.8958 35.75 40.8958 32.2708 39.2917 29.5L23.6042 2.39584C22 -0.37499 18 -0.37499 16.3958 2.39584L0.708332 29.5C-0.895835 32.2708 1.10416 35.75 4.3125 35.75ZM20 21.1667C18.8542 21.1667 17.9167 20.2292 17.9167 19.0833V14.9167C17.9167 13.7708 18.8542 12.8333 20 12.8333C21.1458 12.8333 22.0833 13.7708 22.0833 14.9167V19.0833C22.0833 20.2292 21.1458 21.1667 20 21.1667ZM22.0833 29.5H17.9167V25.3333H22.0833V29.5Z"
                          fill="#FFB82E"/>
                </svg>
            </div>
            <div class="title text-center mt-3">
                {{ "temporaryPassword.modalTitle"| translate }}
            </div>
            <div class="body mt-3 ">
                {{ "temporaryPassword.modalLabel1"| translate }}
                <strong>{{ "temporaryPassword.modalLabel2"| translate }}</strong> {{ "temporaryPassword.modalLabel3"| translate }}
            </div>
        </div>
    </p-dialog>
</div>
